module.exports = __webpack_public_path__ + "static/media/icon-search-admin.de09a597.svg";